import { LandingPage } from "@/components/LandingPage";
import "./index.css";

export function App() {
  return <LandingPage />;
}

export default App;
